import { createApp } from 'vue'
import App from './App.vue'
// import './styles/baseStyle.css';

createApp(App).mount('#app')
